import Base from './Base';
import { QueryClientProvider } from '@tanstack/react-query';
import { client } from '../../../../components/rest/react-query';

const OrderDetailsPage = ({ page, getOrder, showFreeItem, Provider }) => {
  return (
    <QueryClientProvider client={client}>
      <Provider>
        <Base page={page} getOrder={getOrder} showFreeItem={showFreeItem} />
      </Provider>
    </QueryClientProvider>
  );
};

export default OrderDetailsPage;
